import { createFileRoute } from "@tanstack/react-router";

import { CreateProductPage } from "@/components/Pages/Products/CreateProduct.page";

export const Route = createFileRoute("/_guard/products/create")({
  component: CreateProductPage,
});
